<!--//@*/*
    //    *RPD  App v0.91 participants
    //    * Copyright (c) 2024, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

<template>
  <!-- eslint-disable -->
  <v-container id="training_report_add" class="mt-13">
    <!-- header -->
    <div class="header d-flex flex-column align-center">
      <p class="mb-0">Reno Police Department</p>
      <p class="mb-0">Special Weapons & Tactics Team</p>
      <p class="">Training After Action Report</p>
      <v-btn
        v-if="print_show"
        color="primary"
        dark
        class="mb-2"
        @click="print_now"
      >
        Print
      </v-btn>
    </div>
    <hr />
    <!-- form -->
    <div id="full" class="full-form">
      <v-form id="full_form" ref="formIn" v-model="valid">
        <!-- header-info -->

        <v-container>
          <div class="black--text">
            <p>
              If you need to add an additional item to a multi-select, add a
              comma and type it in the list after you have selected all the ones
              you want to select.
            </p>
          </div>
          <v-row>
            <v-col cols="12" md="4" lg="4">
              <v-text-field
                id="reporting_officer"
                name="reporting_officer"
                maxlength="60"
                v-model="formIn.reporting_officer"
                label="Reporting Officer/SWAT Team Member"
                ref="reporting_officer"
                counter="60"
              ></v-text-field>
            </v-col>
            <!-- <v-col cols="12" md="4" lg="4">
              <v-text-field
                id="casenum"
                name="casenum"
                maxlength="8"
                v-model="formIn.case_num"
                label=" Case #"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" lg="4">
              <v-text-field
                id="outside_agency_num"
                name="outside_agency_num"
                maxlength="60"
                v-model="formIn.outside_agency_num"
                label="Outside Agency Case #"
                ref="outside_agency_num"
              ></v-text-field>
            </v-col> -->
          </v-row>
          <v-row>
            <v-col cols="12" md="6" lg="6">
              <v-text-field
                type="date"
                id="date"
                name="date"
                maxlength="60"
                v-model="formIn.trn_date"
                label="Date"
                ref="date"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" lg="6">
              <v-text-field
                v-mask="'##:##'"
                id="time"
                name="time"
                maxlength="60"
                v-model="formIn.trn_time"
                label="Time"
                ref="time"
                placeholder="##:##"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row> </v-row>

          <v-row>
            <v-col cols="12" md="6" lg="6" class="d-flex">
              <v-combobox
                id="mission_type"
                clearable
                v-model="formIn.mission_type"
                :items="['Warrant', 'QRF', 'DVP', 'HRT']"
                label="Mission Type, select all that apply."
                multiple
                attach
              ></v-combobox>
            </v-col>
            <v-col cols="12" md="6" lg="6">
              <v-select
                class=""
                id="specialty"
                v-model="formIn.select_specialty"
                :items="specialty"
                item-text="spec_name"
                item-value="spec_name"
                label="Specialty"
                ref="specialty"
                attach
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" lg="6">
              <v-text-field
                id="deployment"
                name="deployment"
                maxlength="60"
                v-model="formIn.deployment"
                label="Deployment"
                ref="deployment"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" lg="6">
              <v-text-field
                id="location"
                name="location"
                maxlength="60"
                v-model="formIn.location"
                label="Location"
                ref="location"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" lg="6">
              <v-select
                id="shots_fired"
                v-model="formIn.shots_fired"
                :items="['No', 'Yes']"
                label="Shots Fired"
                attach
              ></v-select>
            </v-col>
            <v-col cols="12" md="6" lg="6">
              <v-combobox
                id="risk-box6"
                clearable
                v-model="formIn.select_risk_cbox"
                :items="risk_combobox"
                label="Force, Select all that apply or create a new one."
                multiple
                attach
              ></v-combobox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" lg="6">
              <v-combobox
                id="Breach"
                clearable
                v-model="formIn.breach"
                :items="['Mechanical', 'Shotgun', 'EB']"
                label="Breach, select all that apply."
                multiple
                attach
              ></v-combobox>
            </v-col>
            <v-col cols="12" md="6" lg="6">
              <v-select
                class=""
                id="gas"
                v-model="formIn.gas"
                :items="['No', 'Yes']"
                label="Gas"
                attach
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" lg="6">
              <v-combobox
                id="NFDD"
                v-model="formIn.nfdd"
                :items="['No', 'Yes']"
                label="NFDD"
                attach
              ></v-combobox>
            </v-col>
            <v-col cols="12" md="6" lg="6">
              <v-combobox
                clearable
                id="property_damage"
                v-model="formIn.property_damage"
                :items="[
                  'No',
                  '40mm',
                  'Cameras',
                  'Fences',
                  'Doors',
                  'Windows',
                  'Walls',
                ]"
                label="Property Damage, select all that appl."
                multiple
                attach
              ></v-combobox>
            </v-col>
          </v-row>
        </v-container>

        <!-- Tactics -->
        <v-container>
          <div class="black--text">
            <p>
              If you need to add an additional item to a multi-select, add a
              comma and type it in the list after you have selected all the ones
              you want to select.
            </p>
          </div>

          <div
            class="section-header white--text d-flex justify-start align-center"
          >
            <p class="mb-0 ml-6">TACTICS & TECHNIQUES</p>
          </div>

          <v-row class="">
            <v-col cols="12" md="12" lg="12">
              <v-combobox
                id="tactic-box1"
                clearable
                v-model="formIn.select_tactic"
                :items="tactics"
                label="Select all that apply or create a new one."
                multiple
                attach
              ></v-combobox>
            </v-col>
          </v-row>
        </v-container>

        <!-- Risk Management -->
        <v-container>
          <div
            class="section-header white--text d-flex justify-start align-center"
          >
            <p class="mb-0 ml-6">RISK MANAGEMENT</p>
          </div>

          <v-row class="">
            <v-col
              cols="12"
              md="12"
              lg="12"
              class="d-flex flex-row justify-space-between"
            >
              <v-select
                class="mr-4"
                id="risk-box1"
                v-model="formIn.select_risk_officers"
                :items="risk_officers"
                label="Officers"
                attach
              ></v-select>
              <v-select
                id="risk-box2"
                v-model="formIn.select_risk_suspects"
                :items="risk_suspects"
                label="Suspects"
                attach
              ></v-select>
            </v-col>
          </v-row>

          <!-- row 2 -->
          <v-row class="">
            <v-col
              cols="12"
              md="12"
              lg="12"
              class="d-flex flex-row justify-space-between"
            >
              <v-select
                class="mr-4"
                id="risk-box3"
                v-model="formIn.select_risk_victims"
                :items="risk_victims"
                label="Victims"
                attach
              ></v-select>
              <v-select
                id="risk-box4"
                v-model="formIn.select_risk_citizens"
                :items="risk_citizens"
                label="Citizens"
                attach
              ></v-select>
            </v-col>
          </v-row>
          <v-row class="">
            <v-col
              cols="12"
              md="12"
              lg="12"
              class="d-flex flex-row justify-space-between"
            >
              <v-select
                class="mr-4"
                id="risk-box5"
                v-model="formIn.select_risk_shots"
                :items="risk_shots"
                label="Shots Fired"
                attach
              ></v-select>
              <v-combobox
                id="risk-box6"
                clearable
                v-model="formIn.select_risk_cbox"
                :items="risk_combobox"
                label="Risk, Select all that apply or create a new one."
                multiple
                attach
              ></v-combobox>
            </v-col>
          </v-row>
        </v-container>

        <!-- Associated Documentation -->
        <v-container>
          <div
            class="section-header white--text d-flex justify-start align-center"
          >
            <p class="mb-0 ml-6">ASSOCIATED DOCUMENTATION</p>
          </div>

          <v-row class="">
            <v-col cols="12" md="12" lg="12">
              <v-combobox
                id="docs-box1"
                v-model="formIn.select_associated_docs"
                :items="docs"
                label="Select all that apply or create a new one."
                multiple
                attach
              ></v-combobox>
            </v-col>
          </v-row>

          <p>
            To upload a file, please select the paperclip area below and then
            use the upload button. The maximum file size is 200 MB. On the
            server the file names will be changed to force uniqueness.
          </p>
          <v-row class="">
            <v-col cols="12" md="12" lg="12" class="d-flex">
              <v-file-input
                v-if="showfileinput"
                ref="fileInput"
                id="file"
                show-size
                label="File input"
              ></v-file-input>
              <v-btn
                class="ml-2"
                style="position: relative; top: 10px"
                @click="upload"
                >Upload</v-btn
              >
            </v-col>
          </v-row>
          <v-row class="">
            <v-col cols="12" md="12" lg="12" class="d-flex">
              <ul>
                <li v-for="file in lst_files" :key="file.train_filesId">
                  <a
                    :href="file.fullpath"
                    target="_blank"
                    style="hyphens: auto; word-wrap: break-word"
                    >{{ file.filename }}</a
                  >
                  <v-btn
                    @click="del_trn_file(file.train_filesId)"
                    class="ml-1"
                    icon
                    color="black"
                    style="position: relative; top: -2px"
                  >
                    <v-icon>$delete</v-icon>
                  </v-btn>
                </li>
              </ul>
            </v-col>
          </v-row>
        </v-container>

        <!-- COORDINATING/PARTICIPATING AGENCIES OR OFFICERS -->

        <v-container id="participating">
          <div
            class="section-header white--text d-flex justify-start align-center"
          >
            <p class="mb-0 ml-6">
              COORDINATING/PARTICIPATING AGENCIES OR OFFICERS
            </p>
          </div>

          <v-row>
            <v-col
              cols="12"
              md="12"
              lg="12"
              class="d-flex flex-row justify-space-between"
            >
              <v-data-table
                id="part_agencies"
                :headers="part_headers"
                :items="participants"
                :items-per-page="10"
                sort-by="name"
                class="participant-data-table elevation-1 mt-3"
              >
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-spacer></v-spacer>

                    <!-- New Participating dialog -->
                    <v-dialog
                      v-model="openDialog_newpart_show"
                      max-width="500px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="primary"
                          dark
                          class="mb-2"
                          v-bind="attrs"
                          @click="openDialog_newpart"
                        >
                          Add/Edit Agency/Division/Unit
                        </v-btn>
                      </template>

                      <!-- V Card -->
                      <v-card class="add-to-paticipating">
                        <v-card-title>
                          <!-- FORM TITLE -->
                          <span class="text-h5">{{ formTitle_newpart }}</span>
                        </v-card-title>

                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col
                                cols="12"
                                md="12"
                                lg="12"
                                class="d-flex flex-row justify-space-between"
                              >
                                <v-select
                                  class="mr-4"
                                  id="part_add_name"
                                  v-model="addpart.part_name"
                                  :items="part_participants"
                                  label="Name/Agency/Division/Unit"
                                  attach
                                ></v-select>
                              </v-col>
                            </v-row>
                            <v-row class="">
                              <v-col
                                cols="12"
                                md="12"
                                lg="12"
                                class="d-flex flex-row justify-space-between"
                              >
                                <v-select
                                  id="part_add_assignment"
                                  v-model="addpart.part_assignment"
                                  :items="part_assignments"
                                  label="Assignment"
                                  attach
                                ></v-select>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="newpartCloseDialog"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="save_train_rep_newpart"
                          >
                            Save
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <v-dialog v-model="dialogDelete_newpart" max-width="500px">
                      <v-card>
                        <v-card-title class="text-h5"
                          >Are you sure you want to delete this
                          item?</v-card-title
                        >
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="blue darken-1" text @click="closeDelete"
                            >Cancel</v-btn
                          >
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="deleteItemConfirm"
                            >OK</v-btn
                          >
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                </template>

                <!-- END DIALOG -->

                <template v-slot:item.actions="{ item }">
                  <v-icon class="pa-3" @click="editItem_newpart(item)"
                    >$edit</v-icon
                  >
                  <v-icon class="pa-3" @click="deleteItem_newpart(item)"
                    >$del</v-icon
                  >
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>

        <!-- ROSTER AND ASSIGNMENTS -->

        <v-container id="roster">
          <div
            class="section-header white--text d-flex justify-start align-center"
          >
            <p class="mb-0 ml-6">ROSTER AND ASSIGNMENTS</p>
          </div>

          <v-row>
            <v-col
              cols="12"
              md="12"
              lg="12"
              class="d-flex flex-row justify-space-between"
            >
              <v-data-table
                :headers="roster_headers"
                :items="items_roster"
                :items-per-page="10"
                sort-by="name"
                class="roster-data-table elevation-1 mt-3"
              >
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-spacer></v-spacer>

                    <!-- Roster and Assignment dialog -->
                    <v-dialog
                      v-model="openDialog_newRandA_show"
                      max-width="500px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="primary"
                          dark
                          class="mb-2"
                          v-bind="attrs"
                          @click="openDialog_newRandA"
                        >
                          New Roster/Assignment
                        </v-btn>
                      </template>

                      <!-- V Card -->
                      <v-card class="add-to-roster">
                        <v-card-title>
                          <span class="text-h5">{{ formTitle_addroster }}</span>
                        </v-card-title>

                        <v-card-text>
                          <v-container>
                            <v-row class="">
                              <v-col
                                cols="12"
                                md="12"
                                lg="12"
                                class="d-flex flex-row justify-space-between"
                              >
                                <v-select
                                  class="mr-4"
                                  id="roster_add_name"
                                  v-model="roster_edit_item.roster_name"
                                  :items="roster_names"
                                  item-text="rstr_name"
                                  item-value="rstr_name"
                                  label="Name"
                                  attach
                                ></v-select>
                                <v-select
                                  id="roster_add_present"
                                  v-model="roster_edit_item.roster_present"
                                  :items="roster_ispresent"
                                  label="Present"
                                  attach
                                ></v-select>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col
                                cols="12"
                                md="12"
                                lg="12"
                                class="d-flex flex-row justify-space-between"
                              >
                                <v-select
                                  class="mr-4"
                                  id="roster_add_name"
                                  v-model="roster_edit_item.roster_assignment"
                                  :items="roster_assignments"
                                  item-text="assgn_name"
                                  item-value="assgn_name"
                                  label="Assignment"
                                  attach
                                ></v-select>
                                <v-select
                                  id="roster_add_team"
                                  v-model="roster_edit_item.roster_team"
                                  :items="roster_teams"
                                  item-text="team_name"
                                  item-value="team_name"
                                  label="Team"
                                  attach
                                ></v-select>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="rosterCloseDialog"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="save_train_rep_roster"
                          >
                            Save
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <v-dialog v-model="dialogDelete_newRandA" max-width="500px">
                      <v-card>
                        <v-card-title class="text-h5"
                          >Are you sure you want to delete this
                          item?</v-card-title
                        >
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="blue darken-1" text @click="closeDelete"
                            >Cancel</v-btn
                          >
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="deleteItemConfirm"
                            >OK</v-btn
                          >
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                </template>

                <template v-slot:item.actions="{ item }">
                  <v-icon class="pa-3" @click="editItem_newRandA(item)"
                    >$edit</v-icon
                  >
                  <v-icon class="pa-3" @click="del_train_rep_roster_names(item)"
                    >$del</v-icon
                  >
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>

        <!-- NARRATIVE -->
        <v-container>
          <div
            class="section-header mb-5 white--text d-flex justify-start align-center"
          >
            <p class="mb-0 ml-6">NARRATIVE</p>
          </div>

          <v-card>
            <v-row class="">
              <v-col cols="12" md="12" lg="12">
                <h4 class="ml-4">SITUATION:</h4>
                <v-textarea
                  maxlength="4000"
                  v-model="formIn.situation"
                  class="sit-text pa-4"
                  name="situation"
                  counter="4000"
                  value="Doing me a frighten heck fluffer yapper what a nice floof, such treat very good spot doggo. Maximum borkdrive smol borking doggo with a long snoot for pats shibe very good spot wow very biscit blep, blop yapper heckin angery woofer waggy wags"
                  hint="describe the situation"
                ></v-textarea>
                <h4 class="ml-4">MISSION:</h4>
                <v-textarea
                  auto-grow
                  v-model="formIn.mission"
                  class="sit-text pa-4"
                  name="mission"
                  value="Bacon ipsum dolor amet short ribs jowl andouille sirloin, frankfurter biltong tri-tip flank. Ham porchetta sirloin boudin beef ribs pig chuck turkey. Tenderloin meatball capicola t-bone, ham hock cow turkey bresaola ball tip fatback shank tri-tip pig ribeye doner. Bresaola tongue pork chop drumstick spare ribs pork loin meatball cow flank. Leberkas short ribs turducken, porchetta jowl burgdoggen ball tip beef ribs pig boudin. Salami boudin fatback shank ball tip"
                  hint="Infinite text"
                ></v-textarea>
                <h4 class="ml-4">NOTES/COMMENTS:</h4>
                <v-textarea
                  auto-grow
                  v-model="formIn.note"
                  class="sit-text pa-4"
                  name="notes"
                  value="Cat ipsum dolor sit amet. Attack feet behind the couch, make kitty stinky face, destroy couch, flop over, give attitude, hide when guests come over, hopped up on goofballs, hunt anything that moves, leave dead animals as gifts, chew iPad power cord, shake treat, claw drapes, sweet beast under the bed. Why must they do that? Swat at dog, make muffins, intently stare at the same spot, need to chase tail, big stretch, flop over, intently sniff hand"
                  hint="Infinite text"
                ></v-textarea>
                <h4 class="ml-4">EXPENDED EQUIPMENT:</h4>
                <v-textarea
                  v-model="formIn.equipment"
                  class="sit-text pa-4"
                  name="expended"
                  maxlength="4000"
                  counter="4000"
                  value="Vroom vroom, turbocharged engine, sleek design, and aerodynamic curves. Leather seats, sunroof, and alloy wheels. Revving up the engine, hitting the open road, feeling the wind in your hair. From zero to sixty in seconds, the thrill of speed and the joy of driving. Whether it’s a classic muscle car or a modern electric vehicle, the love for cars is universal "
                  hint="enter expended equipment"
                ></v-textarea>

                <!-- <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDialog"
              >Cancel</v-btn
            >
            <v-btn color="blue darken-1" text @click="saveItem_rname"
              >Save</v-btn
            >
          </v-card-actions> -->
              </v-col>
            </v-row>
          </v-card>
        </v-container>
        <v-container>
          <!-- trn EXPENDITURES -->
          <div
            class="section-header mb-5 white--text d-flex justify-start align-center mt-3"
          >
            <p class="mb-0 ml-6">EXPENDITURES</p>
          </div>
          <v-card>
            <v-row class="">
              <v-col cols="6" md="2" lg="2">
                <v-select
                  class="pa-2 py-3"
                  id="NFDD"
                  v-model="exp.nfdd"
                  :items="all50"
                  label="NFDD"
                  attach
                ></v-select>
              </v-col>
              <v-col cols="6" md="2" lg="2">
                <v-select
                  class="pa-2 py-3"
                  id="strip_charge"
                  v-model="exp.strip_charge"
                  :items="all50"
                  label="Strip Charge"
                  attach
                ></v-select>
              </v-col>
              <v-col cols="6" md="2" lg="2">
                <v-select
                  class="pa-2 py-3"
                  id="hinge_charge"
                  v-model="exp.hinge_charge"
                  :items="all50"
                  label="Hinge Charge"
                  attach
                ></v-select>
              </v-col>
              <v-col cols="6" md="6" lg="6">
                <v-select
                  class="pa-2 py-3"
                  id="fluid_impulse_charge"
                  v-model="exp.fluid_impulse_charge"
                  :items="all50"
                  label="Fluid Impulse Charge"
                  attach
                ></v-select>
              </v-col>
            </v-row>
            <!-- exp row2 -->
            <v-row class="">
              <v-col cols="6" md="2" lg="2">
                <v-select
                  class="pa-2 py-3"
                  id="fracture_charge"
                  v-model="exp.fracture_charge"
                  :items="all50"
                  label="Fracture Charge"
                  attach
                ></v-select>
              </v-col>
              <v-col cols="6" md="2" lg="2">
                <v-select
                  class="pa-2 py-3"
                  id="explosives_other"
                  v-model="exp.explosives_other"
                  :items="all50"
                  label="Explosives Other"
                  attach
                ></v-select>
              </v-col>
              <v-col cols="12" md="4" lg="4">
                <v-text-field
                  class="pa-2 py-3"
                  id="explosives_other_name"
                  name="explosives_other_name"
                  maxlength="60"
                  v-model="exp.explosives_other_name"
                  label="Explosives Other Name"
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- exp row 3 -->
            <v-row class="">
              <v-col cols="12" md="4" lg="4">
                <v-select
                  class="pa-2 py-3"
                  id="exact_impact_oc_round"
                  v-model="exp.exact_impact_oc_round"
                  :items="all50"
                  label="Exact Impact OC Round"
                  attach
                ></v-select>
              </v-col>
              <v-col cols="12" md="4" lg="4">
                <v-select
                  class="pa-2 py-3"
                  id="exact_impact_sponge_round"
                  v-model="exp.exact_impact_sponge_round"
                  :items="all50"
                  label="Exact Impact Sponge Round"
                  attach
                ></v-select>
              </v-col>
              <v-col cols="12" md="2" lg="2">
                <v-select
                  class="pa-2 py-3"
                  id="stinger_round"
                  v-model="exp.stinger_round"
                  :items="all50"
                  label="Stinger Round"
                  attach
                ></v-select>
              </v-col>
            </v-row>
            <!-- exp row 4 -->
            <v-row class="">
              <v-col cols="12" md="4" lg="4">
                <v-select
                  class="pa-2 py-3"
                  id="ferret_barricade_penetrating_round"
                  v-model="exp.ferret_barricade_penetrating_round"
                  :items="all50"
                  label="Ferret Barricade Penetrating Round"
                  attach
                ></v-select>
              </v-col>
              <v-col cols="6" md="2" lg="2">
                <v-select
                  class="pa-2 py-3"
                  id="cs_pocket_smoke"
                  v-model="exp.cs_pocket_smoke"
                  :items="all50"
                  label="CS Pocket Smoke"
                  attach
                ></v-select>
              </v-col>
              <v-col cols="6" md="2" lg="2">
                <v-select
                  class="pa-2 py-3"
                  id="cs_triple_chaser"
                  v-model="exp.cs_triple_chaser"
                  :items="all50"
                  label="CS Triple Chaser"
                  attach
                ></v-select>
              </v-col>
              <v-col cols="12" md="2" lg="2">
                <v-select
                  class="pa-2 py-3"
                  id="cs_heat"
                  v-model="exp.cs_heat"
                  :items="all50"
                  label="CS Heat"
                  attach
                ></v-select>
              </v-col>
            </v-row>

            <!-- exp row 5 -->
            <v-row class="">
              <v-col cols="12" md="2" lg="2">
                <v-select
                  class="pa-2 py-3"
                  id="cs_other"
                  v-model="exp.cs_other"
                  :items="all50"
                  label="CS Other"
                  attach
                ></v-select>
              </v-col>
              <v-col cols="12" md="4" lg="4">
                <v-text-field
                  class="pa-2 py-3"
                  id="cs_other_name"
                  name="cs_other_name"
                  maxlength="60"
                  v-model="exp.cs_other_name"
                  label="CS Other Name"
                ></v-text-field>
              </v-col>

              <v-col cols="6" md="2" lg="2">
                <v-select
                  class="pa-2 py-3"
                  id="pepper_ball"
                  v-model="exp.pepper_ball"
                  :items="all50"
                  label="Pepper Ball"
                  attach
                ></v-select>
              </v-col>
              <v-col cols="6" md="2" lg="2">
                <v-select
                  class="pa-2 py-3"
                  id="glass_breaking_rounds"
                  v-model="exp.glass_breaking_rounds"
                  :items="all50"
                  label="Glass Breaking Rounds"
                  attach
                ></v-select>
              </v-col>
            </v-row>

            <!-- exp row 6 -->
            <v-row class="">
              <v-col cols="6" md="2" lg="2">
                <v-select
                  class="pa-2 py-3"
                  id="sting_ball_grenade"
                  v-model="exp.sting_ball_grenade"
                  :items="all50"
                  label="Sting Ball Grenade"
                  attach
                ></v-select>
              </v-col>
              <v-col cols="6" md="3" lg="3">
                <v-select
                  class="pa-2 py-3"
                  id="pocket_smoke_green"
                  v-model="exp.pocket_smoke_green"
                  :items="all50"
                  label="Pocket Smoke Green"
                  attach
                ></v-select>
              </v-col>
              <v-col cols="6" md="2" lg="2">
                <v-select
                  class="pa-2 py-3"
                  id="pocket_smoke_red"
                  v-model="exp.pocket_smoke_red"
                  :items="all50"
                  label="Pocket Smoke Red"
                  attach
                ></v-select>
              </v-col>
              <v-col cols="6" md="3" lg="3">
                <v-select
                  class="pa-2 py-3"
                  id="pocket_smoke_yellow"
                  v-model="exp.pocket_smoke_yellow"
                  :items="all50"
                  label="Pocket Smoke Yellow"
                  attach
                ></v-select>
              </v-col>
            </v-row>
            <!-- exp row 7 -->
            <v-row class="">
              <v-col cols="6" md="2" lg="2">
                <v-select
                  class="pa-2 py-3"
                  id="large_smoke_green"
                  v-model="exp.large_smoke_green"
                  :items="all50"
                  label="Large Smoke Green"
                  attach
                ></v-select>
              </v-col>
              <v-col cols="6" md="2" lg="2">
                <v-select
                  class="pa-2 py-3"
                  id="large_smoke_red"
                  v-model="exp.large_smoke_red"
                  :items="all50"
                  label="Large Smoke Red"
                  attach
                ></v-select>
              </v-col>
              <v-col cols="6" md="2" lg="2">
                <v-select
                  class="pa-2 py-3"
                  id="large_smoke_yellow"
                  v-model="exp.large_smoke_yellow"
                  :items="all50"
                  label="Large Smoke Yellow"
                  attach
                ></v-select>
              </v-col>
              <v-col cols="6" md="2" lg="2">
                <v-select
                  class="pa-2 py-3"
                  id="large_smoke_white"
                  v-model="exp.large_smoke_white"
                  :items="all50"
                  label="Large Smoke White"
                  attach
                ></v-select>
              </v-col>
            </v-row>
          </v-card>
        </v-container>
      </v-form>
      <div class="submit-btn mt-3 d-flex justify-center align-center">
        <v-btn color="primary" dark class="mb-2 mr-3" @click="save_training_rep"
          >submit</v-btn
        >
        <v-btn
          color="primary"
          dark
          class="mb-2"
          @click="cancel_save_training_rep"
          >cancel</v-btn
        >
      </div>
    </div>

    <div class="bottom-space"></div>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  .header p {
    font-size: 1.2em;
    font-weight: 400;
  }

  .full-form,
  #full_form {
    width: 100%;
  }

  // #training_logs {
  //   width: 95%;
  //   height: auto;
  // }

  .section-header {
    height: 48px;
    width: 100%;
    margin: 0 auto;
    background-color: #708e92;
    -moz-border-radius: 5px;
    -webkit-border-radius: 5px;
    border-radius: 5px;
  }

  .section-header p {
    font-size: 0.9375rem;
  }

  .tactic-box:deep .v-menu__content {
    top: 600px !important;
  }

  .alice {
    color: aliceblue;
  }

  .submit-btn {
    width: 100%;
  }

  .submit-btn .v-btn,
  .add-row .v-btn {
    background-color: #fc5c5c;
  }

  .section1 h1 {
    text-shadow: 2px 2px 4px #000000;
  }

  .training-table .v-data-table {
    border: 1px solid darkslateblue;
  }

  .training-table .v-btn__content {
    visibility: hidden !important;
  }

  .log-header .v-btn {
    background-color: #fc5c5c;
  }

  #part_agencies {
    width: 100%;
  }

  .bottom-space {
    margin-bottom: 250px;
  }

  .roster-data-table,
  .participant-data-table {
    width: 100%;
    margin: 0 auto;
  }
  .add-to-roster,
  .add-to-paticipating {
    height: 500px;
  }

  .sit-text:deep .v-label {
    font-size: 28px !important;
    font-weight: 600 !important;
    margin-bottom: 12px !important;
  }

  .sit-text .v-textarea:deep textarea {
    margin-top: 12px !important;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  .section1 {
    justify-content: center;
    width: 100%;
  }
}

/* 1025 media q */
@media (min-width: 1025px) {
  .section1 {
    justify-content: flex-start;
    width: 100%;
  }
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
import banner from "./banner.vue";
export default {
  name: "trainingReport_add",
  components: {},
  mixins: [bus_common],

  // DATA training - return
  data() {
    return {
      showfileinput: true,
      lst_files: [],
      exp: {
        nfdd: 0,
        strip_charge: 0,
        hinge_charge: 0,
        fluid_impulse_charge: 0,
        fracture_charge: 0,
        explosives_other: 0,
        explosives_other_name: "",
        exact_impact_sponge_round: 0,
        exact_impact_oc_round: 0,
        stinger_round: 0,
        ferret_barricade_penetrating_round: 0,
        cs_pocket_smoke: 0,
        cs_triple_chaser: 0,
        cs_heat: 0,
        cs_other: 0,
        pepper_ball: 0,
        glass_breaking_rounds: 0,
        MyProperty: 0,
        sting_ball_grenade: 0,
        pocket_smoke_green: 0,
        pocket_smoke_red: 0,
        pocket_smoke_yellow: 0,
        pocket_smoke_white: 0,
        large_smoke_green: 0,
        large_smoke_red: 0,
        large_smoke_yellow: 0,
        large_smoke_white: 0,
      },
      print_show: false,
      valid: false,
      firstname: "",
      lastname: "",
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => v.length <= 10 || "Name must be less than 10 characters",
      ],
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      openDialog_newpart_show: false,
      dialogDelete_newpart: false,
      openDialog_newRandA_show: false,
      dialogDelete_newRandA: false,
      dialog: false,
      dialogDelete: false,
      roster_edit_item: {},

      //report header info
      formIn_dev: {
        train_repId: 0,
        equipment: "equipment",
        note: "note",
        mission: "mission",
        situation: "situation",
        reporting_officer: "reporting_officer",
        case_num: "99-12345",
        outside_agency_num: "outside_agency_num",
        mission_type: ["QRT"],
        select_specialty: "Sniper AARs",
        deployment: "deployment",
        location: "location",
        trn_date: "",
        trn_time: "14:30",
        select_tactic: ["1. Slow Search"],
        select_risk_officers: "Injured",
        select_risk_suspects: "Injured",
        select_risk_victims: "Injured",
        select_risk_citizens: "Injured",
        select_risk_shots: "Suspects",
        select_risk_cbox: "Use of Force",
        select_associated_docs: ["Threat Matrix Completed"],
        select_assignment: "select_assignment",
        part_name: "part_name",
        part_assignment: "part_assignment",

        roster_name: "roster_name",
        roster_present: "roster_present",
        roster_assignment: "roster_assignment",
        roster_team: "roster_team",

        breach: ["No"],
        gas: "No",
        nfdd: "Yes",
        property_damage: ["No"],
        shots_fired: "No",
        use_of_force: ["No"],
      },
      formIn_new: {
        train_repId: 0,
        equipment: "",
        note: "",
        mission: "",
        situation: "",
        reporting_officer: "",
        case_num: "",
        outside_agency_num: "",
        mission_type: "",
        select_specialty: "Sniper AARs",
        deployment: "",
        location: "",
        trn_date: "",
        trn_time: "",
        select_tactic: "",
        select_risk_officers: "",
        select_risk_suspects: "",
        select_risk_victims: "",
        select_risk_citizens: "",
        select_risk_shots: "",
        select_risk_cbox: "",
        select_associated_docs: "",
        select_assignment: "",
        part_name: "",
        part_assignment: "",

        roster_name: "",
        roster_present: "",
        roster_assignment: "",
        roster_team: "",

        breach: ["No"],
        gas: "No",
        nfdd: "No",
        property_damage: ["No"],
        shots_fired: ["No"],
        use_of_force: ["No"],
      },
      formIn: {
        train_repId: 0,
        equipment: "",
        note: "",
        mission: "",
        situation: "",
        reporting_officer: "",
        case_num: "",
        outside_agency_num: "",
        mission_type: "",
        select_specialty: "Sniper AARs",
        deployment: "",
        location: "",
        trn_date: "",
        trn_time: "",
        select_tactic: "",
        select_risk_officers: "",
        select_risk_suspects: "",
        select_risk_victims: "",
        select_risk_citizens: "",
        select_risk_shots: "",
        select_risk_cbox: "",
        select_associated_docs: "",
        select_assignment: "",
        part_name: "",
        part_assignment: "",

        roster_name: "",
        roster_present: "",
        roster_assignment: "",
        roster_team: "",

        breach: ["No"],
        gas: "No",
        NFDD: "No",
        property_damage: ["No"],
        shots_fired: ["No"],
        use_of_force: ["No"],
      },

      lst_training_logs_col: [
        { text: "Officer", align: "center", sortable: true, value: "name" },
        { text: "Date", align: "center", sortable: true, value: "date" },
        { text: "Case#", align: "center", sortable: true, value: "casenum" },
        { text: "Time", align: "center", sortable: true, value: "time" },
      ],

      lst_training_logs: [
        {
          name: "Smith",
          date: "01/01/2024",
          casenum: "24-00023",
          time: "13:00",
        },
        {
          name: "Jones",
          date: "01/01/2024",
          casenum: "24-00024",
          time: "09:00",
        },
        {
          name: "Barnes",
          date: "01/01/2024",
          casenum: "24-00025",
          time: "23:00",
        },
      ],
      specialty: [],
      // specialty: [
      //   "Explosive Breaching AARs",
      //   "Sniper AARs",
      //   "Ropes AArmRs",
      //   "Team training AARs",
      //   "Mission AARs",
      // ],

      //tactics and training

      tactics: [
        "1. Slow Search",
        "2. Dynamic Clearing",
        "3. Stealth to Contact",
        "4. Area Search",
        "5. Surround & Call-out",
        "6. Chemical Agent Deployed",
        "7. Breach: Manual",
        "8. Breach: S/G",
        "9. Breach: Explosive",
        "10. Noise/Flash Deployed",
        "11. Rake & Break",
        "12. Less Lethal",
        "13. High Rish Surveillence",
        "`4. QRF",
      ],
      //Risk Mamagement

      risk_officers: ["N/A", "Killed", "Injured"],

      risk_suspects: ["N/A", "Killed", "Injured"],

      risk_victims: ["N/A", "Killed", "Injured"],

      risk_citizens: ["N/A", "Killed", "Injured"],

      risk_shots: ["N/A", "Officers", "Suspects"],

      risk_combobox: [
        "Use of Force",
        "Property Damaged",
        "Vehicle Intervention",
      ],

      //associated documentation
      docs: [
        "Threat Matrix Completed",
        "Risk Management Completed",
        "Photos/Videos Taken",
        "CDS Paperwork Completed",
        "Explosive Breach Documents",
        "Blue Team Completed",
      ],

      //coordinating and participating agencies
      part_headers: [
        {
          text: "Name - Agency/Division/Unit",
          align: "start",
          sortable: true,
          value: "part_name",
        },
        { text: "Assignment", value: "part_assignment" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      participants: [],
      editedIndex: -1,

      //  Edit Items

      // new particpants
      editedIndex_newpart: -1,
      addpart: {
        train_rep_partnameId: 0,
        part_name: "",
        part_assignment: "",
      },
      defaultItem_newpart: {
        train_rep_partnameId: 0,
        part_name: "",
        part_assignment: "",
      },

      part_participants: [
        "SPD",
        "WCSO",
        "Airport PD",
        "School PD",
        "Lyon County SO",
        "Carson City SO",
        "Douglas County SO",
        "Secret Service",
        "CINT",
      ],

      part_assignments: ["SWAT", "SRT", "K-9", "Patrol", "Detective"],

      //ROSTER AND ASSIGNMENTS
      editedIndex_roster: -1,
      roster_headers: [
        { text: "Name", align: "start", sortable: false, value: "roster_name" },
        { text: "Present", value: "roster_present" },
        { text: "Assignment", value: "roster_assignment" },
        { text: "Team", value: "roster_team" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      items_roster: [],

      //edited/default Items
      roster_edit_item: {
        train_rep_rosterId: 0,
        roster_name: "",
        roster_present: "",
        roster_assignment: "",
        roster_team: "",
      },
      defaultItem_newRandA: {
        train_rep_rosterId: 0,
        roster_name: "",
        roster_present: "",
        roster_assignment: "",
        roster_team: "",
      },

      // roster names
      roster_teams: [],
      roster_names: [],

      roster_ispresent: ["Yes", "No"],
      roster_assignments: [],

      // Rules
      situationrules: [
        (v) =>
          (v && v.length >= 4000) ||
          "Description must be less than 4000 characters",
      ],

      missionrules: [
        (v) =>
          (v && v.length >= 8000) ||
          "Description must be less than 8000 characters",
      ],

      notesrules: [
        (v) =>
          (v && v.length >= 8000) ||
          "Description must be less than 8000 characters",
      ],

      expendedrules: [
        (v) =>
          (v && v.length >= 4000) ||
          "Description must be less than 4000 characters",
      ],
    };
  },

  //COMPUTED
  computed: {
    all50() {
      const array = [];
      let start = 0;
      let end = 50;
      for (let i = start; i <= end; i++) {
        array.push(i);
      }
      return array;
    },
    formTitle_newpart() {
      return this.editedIndex_newpart === -1
        ? "New Participant/Assignment"
        : "Edit Participant/Assignment";
    },

    formTitle_addroster() {
      return this.editedIndex_roster === -1
        ? "New Roster Name"
        : "Edit Roster Name";
    },
  },
  // WATCH
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  //METHODS aa

  methods: {
    validateLength4k(value) {
      return value.length <= 4000 || "Text must be less than 4,000 characters.";
    },
    del_trn_file(train_filesId) {
      console.log("del_trn_file");

      this.show_loader(true);
      let formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.train_filesId = train_filesId;

      formIn.apiname = "del_trn_file";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.get_trn_files_list(formIn.train_repId);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },
    save_train_expd() {
      console.log("save_train_expd");
      //  console.log("val: " + this.$refs.form.validate());
      //validate

      this.show_loader(true);
      var formIn = this.mno(this.exp);
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;

      formIn.apiname = "save_train_expd";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          //  self.exp = this.mno(data);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },
    // ***print
    print_now() {
      window.open("/print?id=" + this.formIn.train_repId);
    },
    //************ train select gets
    get_specials() {
      this.show_loader(true);
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;

      formIn.apiname = "get_specials";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.specialty = self.mno(data);
          self.specialty.unshift("N/A");
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },
    get_team_names() {
      this.show_loader(true);
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;

      formIn.apiname = "get_team_names";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.roster_teams = self.mno(data);
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },
    get_assgn_names() {
      this.show_loader(true);
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;

      formIn.apiname = "get_assgn_names";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.roster_assignments = self.mno(data);
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },
    get_part_names() {
      return true;
      this.show_loader(true);
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;

      formIn.apiname = "get_part_names";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          console.log("part cnt: " + data.length);
          self.roster_assignments = self.mno(data);
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },
    get_roster_names() {
      this.show_loader(true);
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;

      formIn.apiname = "get_roster_names";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          console.log("nm cnt: " + data.length);
          self.roster_names = self.mno(data);
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },
    //end slecte gets************* */

    cancel_save_training_rep() {
      this.$router.push("/");
    },
    //roster names
    del_train_rep_roster_names(item) {
      this.show_loader(true);
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.train_rep_rosterId = item.train_rep_rosterId;
      formIn.train_rep_rosterId_train_repId =
        item.train_rep_rosterId_train_repId;
      formIn.apiname = "del_train_rep_roster_names";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.items_roster = self.mno(data);
          this.show_loader(false);
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Deleting", msg, "error", null, null);
        });
    },
    get_train_rep_roster_names(train_repId) {
      //items_roster
      console.log("need a funtion herer!!!");
      this.show_loader(true);
      var formIn = this.mno(this.addpart);
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.train_repId = train_repId;

      formIn.apiname = "get_train_rep_roster_names";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.show_loader(false);
          self.items_roster = self.mno(data);
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },

    save_train_rep_roster() {
      console.log("save_train_rep_roster");

      //validate
      //  this.nameRules,e present assignment team

      if (
        this.roster_edit_item.roster_name == "" ||
        this.roster_edit_item.roster_present == "" ||
        this.roster_edit_item.roster_assignment == "" ||
        this.roster_edit_item.roster_team == ""
      ) {
        this.swall_it(
          "Saving Status",
          "Please select and item in all fields before saving.",
          "warning",
          null,
          null
        );
        return true;
      }

      this.show_loader(true);
      var formIn = this.mno(this.roster_edit_item);
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;

      if (!formIn.train_rep_rosterId > 0) {
        formIn.train_rep_rosterId = 0;
      }
      formIn.train_rep_rosterId_train_repId = this.formIn.train_repId;

      formIn.apiname = "save_train_rep_roster";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.rosterCloseDialog();
          self.items_roster = self.mno(data);
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },

    deleteItem_newpart(item) {
      this.show_loader(true);
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.train_rep_partnameId = item.train_rep_partnameId;
      formIn.apiname = "deleteItem_newpart";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.participants = self.mno(data);
          this.show_loader(false);
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Deleting", msg, "error", null, null);
        });
    },
    get_train_participants(train_repId) {
      console.log("need a funtion herer!!!");
      this.show_loader(true);
      var formIn = this.mno(this.addpart);
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.train_repId = train_repId;

      formIn.apiname = "get_train_participants";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.show_loader(false);
          self.participants = self.mno(data);
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Fetching", msg, "error", null, null);
        });
    },

    save_train_rep_newpart() {
      console.log("save_train_rep_newpart");

      //validate
      if (this.addpart.part_assignment == "" || this.addpart.part_name == "") {
        this.swall_it(
          "Saving Status",
          "Please select and item in all fields before saving.",
          "warning",
          null,
          null
        );
        return true;
      }

      this.show_loader(true);
      var formIn = this.mno(this.addpart);
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;

      if (!formIn.train_rep_partnameId > 0) {
        formIn.train_rep_partnameId = 0;
      }
      formIn.train_rep_partnameId_train_repId = this.formIn.train_repId;

      formIn.apiname = "save_train_rep_newpart";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.newpartCloseDialog();
          self.participants = self.mno(data);
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },

    save_training_rep() {
      console.log("save_training_rep");

      //lets try this
      this.save_train_expd();

      //  console.log("val: " + this.$refs.form.validate());
      //validate
      if (!this.validate()) {
        console.log("train add form not val");
      }
      if (this.formIn.reporting_officer == "") {
        this.swall_it(
          "Save Status",
          "Reporting Officer required",
          "warning",
          null,
          null
        );
        return true;
      }

      this.show_loader(true);
      var formIn = this.mno(this.formIn);
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;

      if (!formIn.train_repId > 0) {
        formIn.train_repId = 0;
      }
      if (Array.isArray(formIn.mission_type)) {
        formIn.mission_type = formIn.mission_type.join(",");
      }
      if (Array.isArray(formIn.select_tactic)) {
        formIn.select_tactic = formIn.select_tactic.join(",");
      }
      if (Array.isArray(formIn.select_associated_docs)) {
        formIn.select_associated_docs = formIn.select_associated_docs.join(",");
      }
      if (Array.isArray(formIn.select_risk_cbox)) {
        formIn.select_risk_cbox = formIn.select_risk_cbox.join(",");
      }
      if (Array.isArray(formIn.mission_type)) {
        formIn.mission_type = formIn.mission_type.join(",");
      }
      if (Array.isArray(formIn.breach)) {
        formIn.breach = formIn.breach.join(",");
      }
      if (Array.isArray(formIn.property_damage)) {
        formIn.property_damage = formIn.property_damage.join(",");
      }
      if (Array.isArray(formIn.use_of_force)) {
        formIn.use_of_force = formIn.use_of_force.join(",");
      }

      formIn.apiname = "save_training_rep";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.swall_it("Submit Status ", "Sucess!", "success", null, null);
          setTimeout(() => {
            self.$router.push("/");
          }, 1000);
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },
    validate() {
      // return this.$refs.form.validate();
      console.log("val: " + this.$refs.formIn.validate());
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    message0() {
      alert("To be implemented.");
    },
    message1() {
      alert("This button will submit the form");
    },

    message2() {
      alert(
        "I could not figure out how to make it cancel - looked at all the others, but they all had v-models, not sure how to do it, please show me when done. "
      );
    },

    message3() {
      alert("This button will print the form");
    },
    upload() {
      console.log("empty: " + document.getElementById("file").files[0]);
      if (document.getElementById("file").files[0] == undefined) {
        this.swall_it(
          "Upload Status",
          "Please select a file before uploading.",
          "warning",
          null,
          null
        );
        return true;
      }
      const formData = new FormData();
      formData.append("file", document.getElementById("file").files[0]);
      formData.append("id", this.formIn.train_repId);
      formData.append("email", this.$store.state.user.email);
      formData.append("report_type", "training");

      var self = this;

      this.$store
        .dispatch("uploadfile", formData)
        .then((data) => {
          console.log("upload finh");
          this.showfileinput = false;

          self.swall_it(
            "Upload Status",
            data + " uploaded",
            "success",
            null,
            null
          );
          setTimeout(() => {
            self.get_trn_files_list();
            self.showfileinput = true;
          }, 750);
        })
        .catch((msg) => {
          this.show_loader(false);
          self.mrbreakpoint("err");
          console.log(msg);
          // this.swall_it("Error Fetching Expended", msg, "error", null, null);
        });
    },
    openDialog_newpart() {
      this.openDialog_newpart_show = true;
      console.log("openDialog_newpart");
      this.addpart = this.mno(this.defaultItem_newpart);
    },
    editItem_newpart(item) {
      this.addpart = this.mno(item);
      this.openDialog_newpart_show = true;
    },

    newpartCloseDialog() {
      this.openDialog_newpart_show = false;
      this.$nextTick(() => {
        this.addpart = this.mno(this.defaultItem_newpart);
        this.editedIndex_newpart = -1;
      });
    },

    // newRandA
    openDialog_newRandA() {
      this.editedIndex_roster = -1;
      this.openDialog_newRandA_show = true;
      console.log("openDialog_newRandA");
      this.addpart = this.mno(this.defaultItem_newRandA);
    },
    editItem_newRandA(item) {
      this.editedIndex_roster = 1;
      this.roster_edit_item = this.mno(item);
      this.openDialog_newRandA_show = true;
    },

    newRandACloseDialog() {
      this.openDialog_newRandA_show = false;
      this.$nextTick(() => {
        this.addpart = this.mno(this.defaultItem_newRandA);
        this.editedIndex_newRandA = -1;
      });
    },

    editItem(item) {
      this.editedIndex = this.participants.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.participants.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.participants.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    // save_train_rep_newpart() {
    //   this.participants.push(this.addpart);
    //   // this.close();
    //   this.openDialog_newpart_show = false;
    // },
    rosterCloseDialog() {
      this.openDialog_newRandA_show = false;
      this.roster_edit_item = this.mno(this.defaultItem_newRandA);
    },
    fetch_train_expd(train_repId) {
      console.log("fetch_train_expd");
      //  console.log("val: " + this.$refs.form.validate());
      //validate

      this.show_loader(true);
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.train_repId = train_repId;

      formIn.apiname = "fetch_train_expd";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.exp = this.mno(data);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error Fetching Expended", msg, "error", null, null);
        });
    },
    fetch_train_rep() {
      console.log("fetch_train_rep");
      //  console.log("val: " + this.$refs.form.validate());
      //validate
      if (!this.validate()) {
        console.log("train add form not val");
      }

      this.show_loader(true);
      var formIn = this.mno(this.formIn);
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.train_repId = this.$route.params.id;

      formIn.apiname = "fetch_train_rep";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.formIn = self.mno(data);
          self.formIn.select_tactic = data.select_tactic.split(",");
          self.formIn.select_risk_cbox = data.select_risk_cbox.split(",");
          self.formIn.select_associated_docs =
            data.select_associated_docs.split(",");

          self.formIn.mission_type = data.mission_type.split(",");
          self.formIn.breach = data.breach.split(",");
          self.formIn.property_damage = data.property_damage.split(",");
          self.formIn.use_of_force = data.use_of_force.split(",");

          self.formIn.trn_date = self.format_date_sql(self.formIn.trn_date);
          self.get_train_participants(self.formIn.train_repId);
          self.get_train_rep_roster_names(self.formIn.train_repId);
          self.fetch_train_expd(self.formIn.train_repId);
          self.get_trn_files_list(self.formIn.train_repId);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },
    add_train_rep_min() {
      console.log("add_train_rep_min");
      //  console.log("val: " + this.$refs.form.validate());
      //validate
      if (!this.validate()) {
        console.log("train add form not val");
      }

      this.show_loader(true);
      var formIn = this.mno(this.exp);
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;

      formIn.apiname = "add_train_rep_min";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.formIn = self.mno(data);
          let id = self.formIn.train_repId;
          //    self.formIn = self.mno(self.formIn_dev);
          self.formIn.train_repId = id;
          self.formIn.trn_date = self.format_date_sql(new Date());

          setTimeout(() => {
            self.add_train_expd_min();
          }, 500);

          // self.formIn.trn_date = self.format_date_us(self.formIn.trn_date);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },
    add_train_expd_min() {
      console.log("add_train_expd_min");
      //  console.log("val: " + this.$refs.form.validate());
      //validate
      //this.mrbreakpoint("add_train_expd_min");

      this.show_loader(true);
      var formIn = this.mno(this.exp);
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;

      formIn.train_rep_eq_expId_train_repId = this.formIn.train_repId;

      formIn.apiname = "add_train_expd_min";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.exp = this.mno(data);
          // self.formIn = self.mno(data);
          // let id = self.formIn.train_repId;
          // self.formIn = self.mno(self.formIn_dev);
          // self.formIn.train_repId = id;
          // self.formIn.trn_date = self.format_date_sql(new Date());
          // self.formIn.trn_date = self.format_date_us(self.formIn.trn_date);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },
    get_trn_files_list() {
      console.log("get_trn_files_list");

      this.show_loader(true);
      var formIn = this.mno(this.exp);
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.train_repId = this.formIn.train_repId;

      formIn.apiname = "get_trn_files_list";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.lst_files = self.mno(data);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },

    // INIT
    init() {
      console.log("train_repid: " + this.$route.params.id);
      if (this.$route.params.id == null) {
        this.add_train_rep_min();
        this.print_show = false;
      } else {
        this.fetch_train_rep();
        this.print_show = true;
      }
      this.get_specials();
      this.get_team_names();
      this.get_roster_names();
      this.get_part_names();
      this.get_assgn_names();
      // this.formIn = this.mno(this.formIn_dev);
      setTimeout(() => {
        //set new link to ornage
        let lstlinks = document.querySelectorAll(".menulink");
        console.log("link lengths: " + lstlinks.length);
        for (let index = 0; index < lstlinks.length; index++) {
          const element = lstlinks[index];
          element.style.color = "white";
        }
        document.getElementById("trainlink").style.color = "orange";
      }, 500);
    },
  },

  // mounted
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
